import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Joyillula';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'

// Default landing after login. Role-specific landings are resolved by
// `entryForRole` (see below) and used by ProtectedRoute / PublicRoute.
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/portal/dashboard`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const ROLE_ENTRY = {
	CUSTOMER: `${APP_PREFIX_PATH}/portal/dashboard`,
	STAFF: `${APP_PREFIX_PATH}/admin/dashboard`,
	ADMIN: `${APP_PREFIX_PATH}/admin/dashboard`,
}

export const entryForRole = (role) => ROLE_ENTRY[role] || AUTHENTICATED_ENTRY

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
